<template>
  <div>
    <b-row class="mt-2">
      <b-col>
        <b-card>
          <b-card-header
            class="pb-1"
          >
            <b-card-title> {{ $t('Days of the Week') }} </b-card-title>
          </b-card-header>

          <b-card-body>
            <b-col
              v-for="(day, index) in checkBoxOptions"
              :key="index"
              class="mt-1"
            >
              <b-form-checkbox
                v-model="selectedDaysOfTheWeek"
                :value="day"
                :disabled="isReadonly"
                class="mt-1"
              >
                {{ day }}
              </b-form-checkbox>
            </b-col>

            <!-- button -->
            <div class="text-center mt-2">
              <Button
                v-if="getUserPermission('MODIFY_SYSTEM_SETUP')"
                :label="buttonLabel"
                :loading="isLoading"
                :disabled="isDisabled"
                size="lg"
                @click="saveWorkingHoliday"
              />
            </div>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
    <FullScreenSpinner :show="showSpinner" />
  </div>

</template>

<script>
import {
  BCard, BCardHeader, BCardTitle, BCardBody, BRow, BCol, BFormCheckbox,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { mapActions } from 'vuex'
import { sweetAlert } from '@core/mixins/sweetAlert'
import { permissionMixin } from '@core/mixins/permission'
import FullScreenSpinner from '@/views/components/spinner/FullScreenSpinner.vue'
import Button from '../../../../components/button/Button.vue'

export default {
  components: {
    BCard,
    BCardHeader,
    BCardTitle,
    BCardBody,
    BRow,
    BCol,
    BFormCheckbox,
    Button,
    FullScreenSpinner,
  },
  directives: {
    Ripple,
  },
  mixins: [sweetAlert, permissionMixin],
  data() {
    return {
      selectAll: false,
      pagesSelect: [],
      buttonLabel: this.$t('Edit'),
      isDisabled: false,
      isLoading: false,
      showSpinner: false,
      isReadonly: true,
      workingDayFormData: {
        config: [],
      },
      checkBoxOptions: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
      selectedDaysOfTheWeek: [],
    }
  },
  mounted() {
    this.fetchWorkingDays()
  },
  methods: {
    ...mapActions({
      getWorkingDays: 'operations/getWorkingDaysList',
      updateWorkingDays: 'operations/updateWorkingDaysAction',
    }),
    saveWorkingHoliday() {
      if (this.buttonLabel === this.$t('Save Changes')) {
        this.confirm(this.handleSubmit, { text: this.$t('Are you sure you want to Update this Working Days?') })
      } else {
        this.isReadonly = false
        this.isEditable = true
        this.buttonLabel = this.$t('Save Changes')
      }
    },
    async handleSubmit() {
      try {
        this.isLoading = true
        this.isDisabled = true
        this.workingDayFormData.config = this.transformDaysOfTheWeekData(this.selectedDaysOfTheWeek)
        const response = await this.updateWorkingDays(this.workingDayFormData)

        const { status } = await response
        if (status === 200) {
          this.alertSuccess({ text: this.$t('Your request to Update Working Days was successful') })
          this.fetchWorkingDays()
          this.isReadonly = true
          this.isEditable = true
          this.isDisabled = false
          this.isLoading = false
          this.buttonLabel = this.$t('Edit')
        }
      } catch (error) {
        const yourRequest = this.$t('Your request to Update Working Days failed. Reason:')
        this.alertError({ text: `${yourRequest} ${error}` })
      } finally {
        this.isEditable = true
        this.isDisabled = false
        this.isLoading = false
      }
    },
    async fetchWorkingDays() {
      try {
        this.showSpinner = true
        const response = await this.getWorkingDays()
        const { status, data } = response
        if (status === 200 && data.data) {
          const transformResponse = data.data.map(item => item.day)
          this.selectedDaysOfTheWeek = transformResponse
        }
      } catch (error) {
        this.alertError({ text: error })
      } finally {
        this.showSpinner = false
      }
    },
    transformDaysOfTheWeekData(data) {
      return data.map(item => ({ day: item }))
    },
  },
}
</script>

<style lang="scss" scoped>
.business-card .business-items .business-item {
    border: none;
}
.business-card {
  min-height: 45.313rem;
}
</style>
